/**
 * Real-time listener for the current user's notifications.
 * Returns notifications, unread count, loading, and error state.
 */
import { useMemo } from 'react';
import { useAuth } from './useAuth';
import { getNotificationsPath, getNotificationsConstraints } from '@/lib/notifications';
import { useForgeCollection } from './forge';
import type { Notification } from '@/types/models';

export function useNotifications() {
  const { user } = useAuth();
  
  const path = user?.id ? getNotificationsPath(user.id) : null;
  const constraints = user?.id ? getNotificationsConstraints() : [];

  const { data: notifications, loading, error } = useForgeCollection<Notification>(path, constraints);

  const unreadCount = useMemo(
    () => notifications.filter((n) => !n.read).length,
    [notifications],
  );

  return {
    notifications,
    unreadCount,
    loading,
    error,
  };
}
